import { AbstractControl, ValidatorFn } from '@angular/forms';

export function vueZerosPhoneFormatValidator(): ValidatorFn {
	return (control: AbstractControl) => {
		const allNumbersAreZero = (control.value || '').split('').every(char => {
			return isNaN(char) ? true : +char === 0;
		});

		return !control.value || !allNumbersAreZero ? null : { vueZerosPhoneFormat: true };
	};
}
